import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/creditorMailingActions';

import CreditorMailing from './CreditorMailing';

const type = 'creditor_mailing';
export class CreditorMailingContainer extends Component {
  componentDidMount() {
    this.getData();
  }

    getData = () => {
      this.props.dispatch(irActions.getCreditorMailingData({
        type,
        case_uuid: this.props.case_uuid,
      }));
    }

  purchaseData = (format) => {
    this.props.dispatch(irActions.purchaseCreditorMailingData({
      type: this.props.type,
      queryType: type,
      case_uuid: this.props.case_uuid,
      format,
    }));
  }

  render() {
    return (
      <CreditorMailing
        {...this.props}
        type={this.props.type}
        purchaseData={this.purchaseData}
      />
    );
  }
}

CreditorMailingContainer.defaultProps = {
  purchase_right_away: false,
  type: 'creditor_mailing',
  error: null,
  receipt: null,
};

CreditorMailingContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  type: PropTypes.string,
  dataReady: PropTypes.bool.isRequired,
  creditor_mailing: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const creditorMailing = state.get('creditorMailing').toJS();
  return {
    dataReady: creditorMailing.data_ready,
    creditor_mailing: creditorMailing.data,
    receipt: creditorMailing.receipt,
    lastUpdated: creditorMailing.lastUpdated,
    error: creditorMailing.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditorMailingContainer);



// WEBPACK FOOTER //
// ./src/components/case/creditor_mailing/CreditorMailingContainer.js